import { Box, Button, Skeleton } from "@mui/material";
import React, { useState } from "react";

export default function VideoFrame({ videoUrl }) {
  console.log(videoUrl)
  const [isLoaded, setIsLoaded] = useState(false);

  // Function to safely extract YouTube video ID
  const getYoutubeThumbnail = (url) => {
    // console.log(url)
    if (!url) return "";

    let videoId = "";
    const regex =
    /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|live\/|.*[?&]v=)|youtu\.be\/|youtube\.com\/shorts\/)([^"&?\/\s]{11})/;
    const match = url.match(regex);
    if (match) videoId = match[1];

    return videoId
      ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
      : "";
  };

  return (
    <div style={{ position: "relative", width: "100%", height: "120vh" }}>
      {/* Display Thumbnail as Cover */}
      {!isLoaded && (
        <Skeleton
          animation="wave"
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            objectFit: "cover",
          }}
        />
      )}
      <img
        loading="eager"
        decoding="async"
        onLoad={() => setIsLoaded(true)}
        src={getYoutubeThumbnail(videoUrl)}
        alt="Video Thumbnail"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />

      {/* Semi-Transparent Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.2)",
        }}
      />

      {/* Watch Now Button */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#1E1D1D",
            color: "#FFF",
            px: 3,
            py: 1.5,
            textTransform: "capitalize",
            fontSize: { xs: "18px", md: "24px" },
            borderRadius: 4,
            fontWeight: 600,
            "&:hover": {
              color: "#1E1D1D",
              backgroundColor: "#FFF",
            },
          }}
          onClick={() => videoUrl && window.open(videoUrl, "_blank")}
        >
          Watch Now
        </Button>
      </div>
    </div>
  );
}
